// Service 21 — บัญชีและภาษีสำหรับชาวต่างชาติและนิติบุคคลที่มีผู้ถือหุ้นต่างชาติ
// อ้างอิงหลัก: กรมสรรพากร (rd.go.th) — ประมวลรัษฎากร มาตรา 40, 41, 50 ทวิ, 65, 77/1 เป็นต้น,
// คำสั่งกรมสรรพากรที่ ป.161/2566 และ ป.162/2566 (เงินได้จากแหล่งต่างประเทศ),
// กรมพัฒนาธุรกิจการค้า (dbd.go.th) — พ.ร.บ.การบัญชี พ.ศ. 2543 และการยื่นงบการเงิน DBD e-Filing,
// สภาวิชาชีพบัญชีในพระบรมราชูปถัมภ์ (tfac.or.th) — ผู้สอบบัญชีรับอนุญาตและผู้ทำบัญชี,
// สำนักงานประกันสังคม (sso.go.th), ธนาคารแห่งประเทศไทย (bot.or.th),
// สำนักงานคณะกรรมการกฤษฎีกา (krisdika.go.th),
// HCCH Apostille Convention (hcch.net) — มีผลกับประเทศไทยวันที่ 28 กุมภาพันธ์ 2570
// Client-safe definitions only — no heavy FAQ payload here.

export type TaxFaqCategory =
  | "tax-residency"
  | "personal-income-tax"
  | "foreign-income-remittance"
  | "tax-id-efiling"
  | "withholding-vat"
  | "corporate-accounting"
  | "dta-double-tax"
  | "tax-document-legalization";

export interface TaxCategoryDef {
  slug: TaxFaqCategory;
  titleTh: string;
  titleEn: string;
  descTh: string;
  descEn: string;
  matchTh: RegExp;
  matchEn: RegExp;
}

export const TAX_FAQ_CATEGORIES: TaxCategoryDef[] = [
  {
    slug: "tax-residency",
    titleTh: "ถิ่นที่อยู่ทางภาษีของชาวต่างชาติในไทย (กฎ 183 วัน)",
    titleEn: "Thai tax residency for foreigners (the 183-day rule)",
    descTh:
      "เกณฑ์ 183 วันตามประมวลรัษฎากร มาตรา 41 การนับวันในปีภาษี ความต่างระหว่างผู้มีถิ่นที่อยู่และผู้ไม่มีถิ่นที่อยู่ และผลต่อขอบเขตเงินได้ที่ต้องเสียภาษีในไทย",
    descEn:
      "The 183-day test under section 41 of the Revenue Code, how days are counted within a tax year, resident vs non-resident status, and how status changes the scope of income taxable in Thailand.",
    matchTh: /183|ถิ่นที่อยู่|ผู้มีถิ่นที่อยู่|นับวัน|ปีภาษี|มาตรา 41/,
    matchEn: /183|residen|tax year|count/i,
  },
  {
    slug: "personal-income-tax",
    titleTh: "ภาษีเงินได้บุคคลธรรมดา แบบ ภ.ง.ด.90 และ ภ.ง.ด.91",
    titleEn: "Personal income tax: PND 90 and PND 91 returns",
    descTh:
      "ประเภทเงินได้ตามมาตรา 40(1)–(8) อัตราภาษีก้าวหน้า ค่าลดหย่อน กำหนดยื่นแบบรายปี และการยื่นภาษีครึ่งปี ภ.ง.ด.94 สำหรับเงินได้บางประเภท",
    descEn:
      "Categories of assessable income under section 40(1)–(8), the progressive rate table, allowances, the annual filing deadline, and the half-year PND 94 return for certain income types.",
    matchTh: /ภ\.ง\.ด\.9|บุคคลธรรมดา|ลดหย่อน|อัตราภาษี|ภ\.ง\.ด\.94|31 มีนาคม/,
    matchEn: /PND ?9|personal income tax|allowance|progressive|deadline/i,
  },
  {
    slug: "foreign-income-remittance",
    titleTh: "เงินได้จากต่างประเทศและการนำเงินเข้าไทย",
    titleEn: "Foreign-source income and remitting money into Thailand",
    descTh:
      "คำสั่งกรมสรรพากรที่ ป.161/2566 และ ป.162/2566 เงินได้ที่นำเข้ามาในไทยตั้งแต่ปีภาษี 2567 บำนาญและเงินออมจากต่างประเทศ และหลักฐานที่ควรเก็บ",
    descEn:
      "Revenue Department Orders P.161/2566 and P.162/2566, income brought into Thailand from tax year 2024 onwards, foreign pensions and pre-2024 savings, and the evidence you should keep.",
    matchTh: /ต่างประเทศ|ป\.161|ป\.162|นำเงินเข้า|บำนาญ|เงินออม|remit/i,
    matchEn: /foreign|remit|P\.?16[12]|pension|savings|offshore/i,
  },
  {
    slug: "tax-id-efiling",
    titleTh: "เลขประจำตัวผู้เสียภาษีและการยื่นแบบออนไลน์",
    titleEn: "Thai tax ID and online filing",
    descTh:
      "การขอเลขประจำตัวผู้เสียภาษี 13 หลักสำหรับชาวต่างชาติ เอกสารที่ใช้ การลงทะเบียน e-Filing ของกรมสรรพากร และการขอคืนภาษี",
    descEn:
      "How a foreigner obtains a 13-digit Thai tax identification number, the documents required, registering for Revenue Department e-Filing, and claiming refunds.",
    matchTh: /เลขประจำตัวผู้เสียภาษี|e-?filing|ยื่นออนไลน์|คืนภาษี|13 หลัก/i,
    matchEn: /tax ?id|TIN|e-?filing|online|refund/i,
  },
  {
    slug: "withholding-vat",
    titleTh: "ภาษีหัก ณ ที่จ่าย และภาษีมูลค่าเพิ่ม",
    titleEn: "Withholding tax and VAT",
    descTh:
      "อัตราหัก ณ ที่จ่ายที่พบบ่อย หนังสือรับรองการหักภาษีตามมาตรา 50 ทวิ เกณฑ์จดทะเบียน VAT 1.8 ล้านบาท แบบ ภ.พ.30 และภาษีขายบริการจากต่างประเทศ",
    descEn:
      "Common withholding rates, the section 50 bis withholding certificate, the THB 1.8 million VAT registration threshold, the monthly PP 30 return, and VAT on services from abroad.",
    matchTh: /หัก ณ ที่จ่าย|50 ทวิ|ภาษีมูลค่าเพิ่ม|ภ\.พ\.30|1\.8 ล้าน|VAT/i,
    matchEn: /withhold|VAT|PP ?30|threshold|50 bis/i,
  },
  {
    slug: "corporate-accounting",
    titleTh: "บัญชี งบการเงิน และภาษีนิติบุคคล",
    titleEn: "Bookkeeping, financial statements and corporate income tax",
    descTh:
      "หน้าที่ตาม พ.ร.บ.การบัญชี พ.ศ. 2543 ผู้ทำบัญชีและผู้สอบบัญชี การประชุมผู้ถือหุ้น การยื่นงบการเงินต่อกรมพัฒนาธุรกิจการค้า แบบ ภ.ง.ด.50 และ ภ.ง.ด.51",
    descEn:
      "Duties under the Accounting Act B.E. 2543, the bookkeeper and licensed auditor, the shareholders' meeting, filing financial statements with the DBD, and the PND 50 and PND 51 returns.",
    matchTh: /งบการเงิน|ผู้สอบบัญชี|ผู้ทำบัญชี|ภ\.ง\.ด\.5|กรมพัฒนาธุรกิจการค้า|พ\.ร\.บ\.การบัญชี|ประชุมผู้ถือหุ้น|ประกันสังคม/,
    matchEn: /financial statement|auditor|bookkeep|PND ?5|DBD|accounting act|social security/i,
  },
  {
    slug: "dta-double-tax",
    titleTh: "อนุสัญญาภาษีซ้อนและหนังสือรับรองถิ่นที่อยู่",
    titleEn: "Double tax agreements and residence certificates",
    descTh:
      "การใช้สิทธิตามอนุสัญญาภาษีซ้อนที่ไทยทำไว้ การขอหนังสือรับรองการมีถิ่นที่อยู่ (ร.อ.22) และหนังสือรับรองการเสียภาษี (ร.อ.21) เพื่อใช้เครดิตภาษีในต่างประเทศ",
    descEn:
      "Claiming relief under Thailand's double tax agreements, obtaining the certificate of residence (R.O.22) and the certificate of tax payment (R.O.21) to support a foreign tax credit.",
    matchTh: /ภาษีซ้อน|อนุสัญญา|ร\.อ\.2|เครดิตภาษี|DTA/i,
    matchEn: /double tax|treaty|DTA|R\.?O\.?2|tax credit|certificate of residence/i,
  },
  {
    slug: "tax-document-legalization",
    titleTh: "แปลและรับรองเอกสารภาษีเพื่อใช้ต่างประเทศ",
    titleEn: "Translating and legalising Thai tax documents for use abroad",
    descTh:
      "การรับรองคำแปลใบเสร็จภาษี หนังสือรับรองการหักภาษี งบการเงิน และหนังสือรับรองถิ่นที่อยู่ ผ่านทนายความผู้ทำคำรับรองลายมือชื่อและเอกสาร และกองสัญชาติและนิติกรณ์ กรมการกงสุล",
    descEn:
      "Certifying translations of Thai tax receipts, withholding certificates, financial statements and residence certificates through a Notarial Services Attorney and the Department of Consular Affairs.",
    matchTh: /รับรองคำแปล|นิติกรณ์|กงสุล|โนตารี|Apostille|สถานทูต|แปลเอกสาร/i,
    matchEn: /translat|legalis|legaliz|notar|apostille|consular|embassy/i,
  },
];

export function getTaxCategoryDef(slug: string): TaxCategoryDef | undefined {
  return TAX_FAQ_CATEGORIES.find((c) => c.slug === slug);
}